/* eslint-disable react/prop-types */

import React from 'react';

import PropTypes from 'prop-types';

import {Get} from '@/api/request';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog} from '@/libs/consoleHelper';
import {newLineHtml} from '@/libs/htmlHelper';

import {POOLING_PARAM_LABEL} from '../../../constants/calibrationWizardConstant';

import './Result.less';

const PROTEIN_REFERENCE = 0;
const PROTEIN_SENSOR = 1;
const BUFFER_REFERENCE = 2;
const BUFFER_SENSOR = 3;

function ResultValue(props) {
  const {label, value, unit} = props;
  const classInputCollumn =
    unit === undefined ? 'div-2colCalibrationResult divInput' : 'div-3colCalibrationResult divInput';

  return (
    <div className={classInputCollumn}>
      <span className="spanStyleInputField"> {newLineHtml(label)} </span>
      <span className="spanStyleInputField"> {value === APPDATA.EMPTY_FIELD ? 0 : value} </span>
      {unit !== undefined && <span className="spanStyleInputField"> {unit} </span>}
    </div>
  );
}

const ViewValue = {
  FIELD_A: APPDATA.KEY.ProteinSensor,
  FIELD_B: APPDATA.KEY.BufferSensor,
};
const ResetField = {
  [ViewValue.FIELD_A]: APPDATA.EMPTY_FIELD,
  [ViewValue.FIELD_B]: APPDATA.EMPTY_FIELD,
};
class ShowResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewValue: ResetField,
    };
    this.mounted = true;
    this.setLoadCellVolumeSensor = this.setLoadCellVolumeSensor.bind(this);
  }

  // this DId mount is calling twice when  rendered
  componentDidMount() {
    this.mounted = true;

    this.setState({
      viewValue: {
        [APPDATA.KEY.BufferSensor]: APPDATA.EMPTY_FIELD,
        [APPDATA.KEY.ProteinSensor]: APPDATA.EMPTY_FIELD,
      },
    });

    this._poolingCapacitance = setInterval(() => {
      this.getLoadCellVolumeSensor();
    }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
  }

  componentWillUnmount() {
    this.mounted = false;

    if (typeof this._poolingCapacitance !== 'undefined') {
      clearInterval(this._poolingCapacitance);
      this._poolingCapacitance = undefined;
    }
  }

  getLoadCellVolumeSensor = () => {
    if (this.mounted === true) {
      Get(APPDATA.API.GET_ALL_SENSOR_VALUE, '', this.setLoadCellVolumeSensor);
    }
  };

  setLoadCellVolumeSensor = (response) => {
    const {viewValue} = this.state;

    if (this.mounted === true) {
      const newViewValue = {...viewValue};

      newViewValue[APPDATA.KEY.ProteinSensor] = parseFloat(response.data.VolumeSensor.sensor0).toFixed(
        APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
      );
      newViewValue[APPDATA.KEY.BufferSensor] = parseFloat(response.data.VolumeSensor.sensor2).toFixed(
        APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
      );

      this.setState(
        {
          viewValue: newViewValue,
        },
        () => {
          consoleLog('Sensor', newViewValue);
        },
      );
    }
  };

  render() {
    const {resultPacket, params} = this.props;
    const {viewValue} = this.state;

    return (
      <div className="calibrationResult">
        {resultPacket !== undefined && resultPacket.length > 0 ? (
          <>
            <div className="calibrationRow div-2col">
              <div style={{width: '100%'}}>
                <b>{params[POOLING_PARAM_LABEL.TEXT][2]}</b>
                <ResultValue
                  label={resultPacket[PROTEIN_REFERENCE].text}
                  value={resultPacket[PROTEIN_REFERENCE].result}
                  unit={params[POOLING_PARAM_LABEL.TEXT][1]}
                />
                <ResultValue
                  label={resultPacket[PROTEIN_SENSOR].text}
                  // value={resultPacket[PROTEIN_SENSOR].result}
                  value={viewValue[APPDATA.KEY.ProteinSensor]}
                  unit={params[POOLING_PARAM_LABEL.TEXT][1]}
                />
              </div>
              <div style={{width: '100%'}}>
                <b>{params[POOLING_PARAM_LABEL.TEXT][3]}</b>
                <ResultValue
                  label={resultPacket[BUFFER_REFERENCE].text}
                  value={resultPacket[BUFFER_REFERENCE].result}
                  unit={params[POOLING_PARAM_LABEL.TEXT][1]}
                />
                <ResultValue
                  label={resultPacket[BUFFER_SENSOR].text}
                  // value={resultPacket[BUFFER_SENSOR].result}
                  value={viewValue[APPDATA.KEY.BufferSensor]}
                  unit={params[POOLING_PARAM_LABEL.TEXT][1]}
                />
              </div>
            </div>
            <div className="calibrationRow">{newLineHtml(params[POOLING_PARAM_LABEL.TEXT][0])}</div>
          </>
        ) : (
          <div className="center">
            <br />
            <br />
            <span>LOADING...</span>
          </div>
        )}
      </div>
    );
  }
}
export default ShowResult;

ShowResult.propTypes = {
  resultPacket: PropTypes.array,
};
ShowResult.defaultProps = {
  resultPacket: [],
};
